<template>
  <div>
    <div class="containerFull" style="min-height:600px">
      <div class="p-grid">
        <div class="p-col-12">
          <h2
            style="border-bottom: 1px solid #cfcfcf;"
            class="p-pb-5 p-mt-6 titulo-admin p-ml-2"
          >
            Listado de Documentos
          </h2>
          <DataTable
            ref="dt"
            :value="itemsList"
            dataKey="id"
            :paginator="true"
            :rows="10"
            :filters="filters"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[5, 10, 25]"
            currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} documentos"
            class="p-datatable-responsive-demo p-mt-5"
            style="margin-bottom:100px"
            :loading="loading"
          >
            <template #header>
              <div
                class="table-header"
                style="align-items: center;display: flex;"
              >
                <Button
                  icon="pi pi-plus"
                  class="p-button-rounded p-button-info p-mr-3"
                  @click="openNew"
                  :disabled="loading"
                  v-tooltip.rigth="'Agregar nuevo'"
                  name="nuevo"
                />
                <span class="p-input-icon-left" style="margin-left: auto;">
                  <i class="pi pi-search" />
                  <InputText
                    v-model="filters['global']"
                    placeholder="Buscar..."
                  />
                </span>
              </div>
            </template>
            <Column field="titulo" header="Titulo" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Titulo</span>
                {{ slotProps.data.titulo }}
              </template>
            </Column>
            <Column field="resumen" header="Resumen" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Resumen</span>
                {{ slotProps.data.resumen }}
              </template>
            </Column>
            <Column field="importancia" header="Importancia" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Importancia</span>
                {{ slotProps.data.importancia }}
              </template>
            </Column>
            <Column field="publicado" header="Publicado" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Publicado</span>
                {{ slotProps.data.publicado == 0 ? "No" : "Si" }}
              </template>
            </Column>
            <Column field="icon" header="Icono" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Icono</span>
                <img
                  :src="`${urlIcons}${slotProps.data.icon}`"
                  alt=""
                  v-if="slotProps.data.icon"
                  height="60"
                />
              </template>
            </Column>
            <Column :exportable="false">
              <template #body="slotProps">
                <span class="p-column-title">Acciones</span>
                <Button
                  icon="mdi mdi-image-off-outline"
                  class="p-button-rounded p-button-danger p-mr-2"
                  @click="deleteIcon(slotProps.data)"
                  v-tooltip.top="'Eliminar icono'"
                  name="eliminarIcono"
                  v-if="slotProps.data.icon"
                />
                <Button
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-success p-mr-2"
                  @click="editItem(slotProps.data)"
                  v-tooltip.top="'Editar'"
                  name="editar"
                />
                <Button
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-warning"
                  @click="confirmDeleteItem(slotProps.data)"
                  v-tooltip.top="'Eliminar'"
                  name="eliminar"
                />
              </template>
            </Column>
          </DataTable>
          <Dialog
            :closable="false"
            :visible="itemDialog"
            :style="{ width: '450px' }"
            header="Detalles de la Información"
            :modal="true"
            class="p-fluid"
            :contentStyle="{ overflow: 'visible' }"
          >
            <div class="p-grid">
              <div class="p-field p-col-12">
                <label for="titulo">Titulo</label>
                <InputText
                  id="titulo"
                  v-model.trim="item.titulo"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !item.titulo }"
                />
                <small class="p-invalid" v-if="submitted && !item.titulo"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-12">
                <label for="resumen">Resumen</label>
                <Textarea
                  v-model.trim="item.resumen"
                  rows="3"
                  cols="12"
                  required="true"
                  :class="{ 'p-invalid': submitted && !item.resumen }"
                />
                <small class="p-invalid" v-if="submitted && !item.resumen"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-12">
                <label for="publicado">Publicado</label>
                <div class="p-formgroup-inline">
                  <div
                    v-for="(tipo_actividad, index) in tipos_estado"
                    :key="index"
                    class="p-field-radiobutton"
                  >
                    <RadioButton
                      :id="index"
                      name="publicado"
                      :value="tipo_actividad.value"
                      v-model="item.publicado"
                      autofocus
                    />
                    <label :for="index">{{ tipo_actividad.name }}</label>
                  </div>
                </div>
              </div>
              <div class="p-field p-col-12">
                <label for="importancia"
                  >Importancia (1-10 donde 1 es de mayor importancia)</label
                >
                <Dropdown
                  v-model="item.importancia"
                  :options="niveles_importancias"
                  optionLabel="text"
                  optionValue="value"
                  placeholder="Selecciona la importancia"
                  required="true"
                  autofocus
                  :class="{
                    'p-invalid': submitted && !item.importancia,
                  }"
                />
                <small class="p-invalid" v-if="submitted && !item.importancia"
                  >La importancia es requerida</small
                >
              </div>
              <div class="p-field p-col-12 p-md-12">
                <label for="archivo" class="custom-file-upload"
                  >Archivo (.pdf)</label
                >
                <input
                  type="file"
                  id="archivo"
                  accept="application/pdf"
                  @change="onUpload($event)"
                />
                <span class="p-ml-3">{{ nombreFile }}</span>
                <span
                  v-if="sizeFile > 0"
                  style="font-size: 12px;font-weight: 700;margin-left: 5px;"
                  >{{ sizeFile.toFixed(2) }}Kb</span
                >
              </div>
              <div class="p-field p-col-12 p-md-12">
                <label for="icono" class="custom-file-upload"
                  >Icono (max 1mb)</label
                >
                <input
                  type="file"
                  id="icono"
                  accept="image/*"
                  @change="onUploadIcon($event)"
                />
                <span class="p-ml-3">{{ nombreFileIcon }}</span>
                <span
                  v-if="sizeFileIcon > 0"
                  style="font-size: 12px;font-weight: 700;margin-left: 5px;"
                  >{{ sizeFileIcon.toFixed(2) }}Kb</span
                >
              </div>
            </div>
            <template #footer>
              <Button
                label="Cancelar"
                icon="pi pi-times"
                class="p-button-text"
                @click="hideDialog"
                name="cancelar"
              />
              <Button
                label="Guardar"
                icon="pi pi-check"
                class="p-button-text"
                @click="saveItem"
                :disabled="loading"
                name="aceptar"
              />
            </template>
          </Dialog>
          <Dialog
            :visible="deleteItemDialog"
            :style="{ width: '450px' }"
            header="Confirmación de eliminación"
            :modal="true"
          >
            <div class="confirmation-content">
              <i
                class="pi pi-exclamation-triangle p-mr-3"
                style="font-size: 2rem"
              />
              <span v-if="item"
                >Esta seguro que desea eliminar la información
                <b>{{ item.titulo }}</b
                >?</span
              >
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteItemDialog = false"
                name="cancelar"
              />
              <Button
                label="Si"
                icon="pi pi-check"
                class="p-button-text"
                @click="deleteItemSelected"
                name="aceptar"
              />
            </template>
          </Dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InformacionService from "../service/informacion.service";
export default {
  metaInfo: {
    title: 'Backoffice - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Backoffice - QualityCare',
        content: 'Administración del sitio web',
      },
    ],
  },
  data() {
    return {
      informacionService: null,
      filters: {},
      item: {},
      itemsList: [],
      itemDialog: false,
      deleteItemDialog: false,
      submitted: false,
      loading: false,
      tipos_estado: [
        { name: "NO", value: 0 },
        { name: "SI", value: 1 },
      ],
      niveles_importancias: [
        { text: 1, value: 1 },
        { text: 2, value: 2 },
        { text: 3, value: 3 },
        { text: 4, value: 4 },
        { text: 5, value: 5 },
        { text: 6, value: 6 },
        { text: 7, value: 7 },
        { text: 8, value: 8 },
        { text: 9, value: 9 },
        { text: 10, value: 10 },
      ],
      archivoFueTocado: false,
      nombreFile: "",
      sizeFile: 0,
      typeFile: "",
      archivoFueTocadoIcon: false,
      nombreFileIcon: "",
      sizeFileIcon: 0,
      typeFileIcon: "",
      urlIcons: process.env.VUE_APP_API_AVATAR,
    };
  },
  created() {
    this.informacionService = new InformacionService();
  },
  mounted() {
    this.recuperarItemsForList();
  },
  methods: {
    recuperarItemsForList() {
      this.loading = true;
      this.informacionService
        .allDocumentsForAdmin()
        .then((result) => {
          if (result.data.data) {
            this.itemsList = [...result.data.data];
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al cargar las informaciones",
            life: 3000,
          });
          this.loading = false;
        });
    },
    openNew() {
      this.file = null;
      this.nombreFile = "";
      this.sizeFile = 0;
      this.typeFile = "";
      this.archivoFueTocado = false;
      this.item = { publicado: 1 };
      this.submitted = false;
      this.itemDialog = true;
    },
    hideDialog() {
      this.itemDialog = false;
      this.submitted = false;
    },
    async saveItem() {
      this.submitted = true;
      if (this.item.titulo && this.item.resumen && this.item.importancia) {
        this.loading = true;
        if (this.item.id) {
          //edicion de item
          let idItemEnEdicion = this.item.id;
          let itemEditado = {};
          let dataAvatar = new FormData();
          if (this.file != null) {
            dataAvatar.append("archivo", this.file);
          }
          if (this.fileIcon != null) {
            dataAvatar.append("icon", this.fileIcon);
          }
          dataAvatar.append("datos", JSON.stringify(this.item));
          await this.informacionService
            .editarInformacion(dataAvatar)
            .then((result) => {
              if (result.data.data) {
                itemEditado = result.data.data;
                this.$set(
                  this.itemsList,
                  this.findIndexById(idItemEnEdicion),
                  itemEditado
                );
                this.$toast.add({
                  severity: "success",
                  summary: "Felicidades",
                  detail: "Item actualizado",
                  life: 3000,
                });
                this.item = {};
                this.itemDialog = false;
                this.loading = false;
                this.resetInputs();
              } else {
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: "Error al guardar",
                  life: 3000,
                });
                this.loading = false;
              }
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });
        } else {
          if (this.file == null) {
            this.$toast.add({
              severity: "warn",
              summary: "Error",
              detail: "Dedes seleccionar un documento",
              life: 3000,
            });
            this.loading = false;
            return false;
          }
          //nuevo item
          let dataAvatar = new FormData();
          dataAvatar.append("archivo", this.file);
          if (this.fileIcon != null) {
            dataAvatar.append("icon", this.fileIcon);
          }
          dataAvatar.append("datos", JSON.stringify(this.item));
          await this.informacionService
            .crearInformacion(dataAvatar)
            .then((result) => {
              if (result.data.data) {
                this.itemsList.push(result.data.data);
                this.$toast.add({
                  severity: "success",
                  summary: "Felicidades",
                  detail: "Item creada",
                  life: 3000,
                });
                this.item = {};
                this.itemDialog = false;
                this.
                this.loading = false;
                this.resetInputs();
              } else {
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: "Error al guardar",
                  life: 3000,
                });
                this.loading = false;
              }
            })
            .catch((err) => {
              this.loading = false;
              console.log(err);
            });
        }
      }
    },
    editItem(item) {
      this.file = null;
      this.nombreFile = "";
      this.sizeFile = 0;
      this.typeFile = "";
      this.archivoFueTocado = false;
      this.item = { ...item };
      this.itemDialog = true;
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.itemsList.length; i++) {
        if (this.itemsList[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    confirmDeleteItem(item) {
      this.item = item;
      this.deleteItemDialog = true;
    },
    deleteItemSelected() {
      this.informacionService
        .eliminarInformacion({ id: this.item.id })
        .then(() => {
          this.itemsList = this.itemsList.filter(
            (val) => val.id !== this.item.id
          );
          this.deleteItemDialog = false;
          this.item = {};
          this.$toast.add({
            severity: "success",
            summary: "Felicidades",
            detail: "Item eliminado",
            life: 3000,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onUpload(event) {
      console.log(event);
      this.nombreFile =
        event.target.files.length == 0 ? "" : event.target.files[0].name;
      this.sizeFile =
        event.target.files.length == 0 ? 0 : event.target.files[0].size / 1024;
      this.typeFile =
        event.target.files.length == 0 ? "" : event.target.files[0].type;

      if (event.target.files.length == 0) {
        this.file = null;
        this.nombreFile = "";
        this.sizeFile = 0;
        this.typeFile = "";
        this.archivoFueTocado = false;
      } else if (this.typeFile.indexOf("pdf") == -1) {
        this.file = null;
        this.nombreFile = "";
        this.sizeFile = 0;
        this.typeFile = "";
        this.archivoFueTocado = false;
        this.$toast.add({
          severity: "warn",
          summary: "Alerta",
          detail: "El archivo debe estar en formato pdf",
          life: 3000,
        });
      } else if (this.sizeFile > 10240) {
        this.file = null;
        this.nombreFile = "";
        this.sizeFile = 0;
        this.typeFile = "";
        this.archivoFueTocado = false;
        this.$toast.add({
          severity: "warn",
          summary: "Alerta",
          detail: "El archivo del archivo no debe ser mayor a 10Mb",
          life: 3000,
        });
      } else if (this.sizeFile <= 0) {
        this.file = null;
        this.nombreFile = "";
        this.sizeFile = 0;
        this.typeFile = "";
        this.archivoFueTocado = false;
        this.$toast.add({
          severity: "warn",
          summary: "Alerta",
          detail: "El archivo debe tipo pdf sebe ser mayor a cero",
          life: 3000,
        });
      } else {
        this.file = event.target.files[0];
        this.archivoFueTocado = true;
      }
    },
    onUploadIcon(event) {
      this.nombreFileIcon =
        event.target.files.length == 0 ? "" : event.target.files[0].name;
      this.sizeFileIcon =
        event.target.files.length == 0 ? 0 : event.target.files[0].size / 1024;
      this.typeFileIcon =
        event.target.files.length == 0 ? "" : event.target.files[0].type;

      if (event.target.files.length == 0) {
        this.fileIcon = null;
        this.nombreFileIcon = "";
        this.sizeFileIcon = 0;
        this.typeFileIcon = "";
        this.archivoFueTocadoIcon = false;
      } else if (
        this.typeFileIcon.indexOf("jpg") == -1 &&
        this.typeFileIcon.indexOf("png") == -1 &&
        this.typeFileIcon.indexOf("jpeg") == -1
      ) {
        this.fileIcon = null;
        this.nombreFileIcon = "";
        this.sizeFileIcon = 0;
        this.typeFileIcon = "";
        this.archivoFueTocadoIcon = false;
        this.$toast.add({
          severity: "warn",
          summary: "Alerta",
          detail: "El archivo debe estar en formato png o jpg",
          life: 3000,
        });
      } else if (this.sizeFileIcon > 1024) {
        this.fileIcon = null;
        this.nombreFileIcon = "";
        this.sizeFileIcon = 0;
        this.typeFileIcon = "";
        this.archivoFueTocadoIcon = false;
        this.$toast.add({
          severity: "warn",
          summary: "Alerta",
          detail: "El archivo del icono no debe ser mayor a 1Mb",
          life: 3000,
        });
      } else {
        this.fileIcon = event.target.files[0];
        this.archivoFueTocadoIcon = true;
      }
    },
    async deleteIcon(item) {
      if (item && item.icon) {
        //edicion de item
        let idItemEnEdicion = item.id;
        let itemEditado = {};
        let data = { id: item.id };
        await this.informacionService
          .eliminarIcon(data)
          .then((result) => {
            if (result.data.data) {
              itemEditado = result.data.data;
              this.$set(
                this.itemsList,
                this.findIndexById(idItemEnEdicion),
                itemEditado
              );
              this.$toast.add({
                severity: "success",
                summary: "Felicidades",
                detail: "Icono eliminado",
                life: 3000,
              });
              this.item = {};
              this.loading = false;
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error al guardar",
                life: 3000,
              });
              this.loading = false;
            }
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
          });
      }
    },
    resetInputs(){
      this.archivoFueTocado= false
      this.nombreFile= ""
      this.sizeFile= 0
      this.typeFile= ""
      this.archivoFueTocadoIcon= false
      this.nombreFileIcon= ""
      this.sizeFileIcon= 0
      this.typeFileIcon= ""
    }
  },
};
</script>

<style lang="scss" scoped>
.tituloUsuarios {
  font-size: 28px;
  font-weight: 400;
  margin-right: 50px;
}
.muyLargo {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}

.p-datatable-responsive-demo .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

@media screen and (max-width: 40em) {
  /deep/ .p-datatable {
    &.p-datatable-responsive-demo {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr > td {
        text-align: left;
        display: block;
        width: 100%;
        float: left;
        clear: left;
        border: 0 none;

        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4em 1em -0.4em -0.4rem;
          font-weight: bold;
        }

        &:last-child {
          border-bottom: 1px solid var(--surface-d);
        }
      }
    }
  }
}
</style>
